<template lang="pug">
    .announcement(v-if="content")
        h2.announcement__title {{ dataPage.headline }}
        router-link.announcement__link(to="/anonsy")
            SvgIcon.announcement__link-icon(name="arrow" width="10" height="18")
            .announcement-item__link-text Назад к событиям
        .announcement__content
            a.announcement__img-wr(:href='content.imgBigSrc' data-fancybox)
                img.announcement__img(:src="content.imgPrev.path" :alt="content.imgPrev.name" :class="{'announcement__img--hide': imgHide}")
            .announcement__description-wr
                .announcement__description
                    p.announcement__description-date {{ content.date }}
                    h4.announcement__description-name {{ content.name }}
                    p.announcement__description-time
                        span Время:
                        | {{ content.time }}
                    p.announcement__description-address
                        span Адрес:
                        | {{ content.address }}
                    .announcement__description-text(v-html='content.description')
</template>

<script>
    // @ is an alias to /src
    import '@/components/common/announcement/announcement.styl';
    import EventBus from '@/eventBus';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'Announcement',
        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
                objImages: [],
                imgHide: true,
                dataPage: null,
            }
        },

        components: {
            SvgIcon,
        },

        created() {
            EventBus.$on('loadAnnouncementPage', params => {
                this.content = null;
                let url = params.url.split('/');
                this.request(params, '/'+url[1]);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        mounted() {
        },

        methods: {
            request(url, link) {
                this.req('AnnouncementsPage:getAnnouncementsPage', {url: link}, res => {
                    this.dataPage = res.content;
                    this.path = url;
                    let data = {
                        url: link,
                        type: url.type
                    };
                    EventBus.$emit('setMenuTopActiveClass', url.url, url.from);
                    this.innerRequest('AnnouncementsPage:getAnnouncementItem', data).then(response => {
                        EventBus.$emit('pagePreloaderHide');
                        if(response.status === 'ok') {
                            this.content = response.announcement;
                            this.objImages = this.objImages.concat({loaded: false, url: this.content.imgPrev.path});
                            this.$nextTick(() => {
                                $('.samedia').removeClass('samedia--hide');
                                $('.footer').removeClass('footer--hide');
                                $('.page__decore--12').removeClass('page__decore--hide-bottom');
                                $('.page__decore--11').removeClass('page__decore--hide-bottom');
                                $('.page__decore--10').removeClass('page__decore--hide-bottom');
                                this.checkImgLoading(this.objImages);
                                this.initFancy();
                                if ($(window).width() > 700) {
                                    this.scrollInit();
                                }
                            });
                        } else {
                            this.$router.push('/404');
                        }
                    });
                }, 'announcement');
            },

            initFancy() {
                $('.announcement__img-wr').fancybox({
                    // toolbar  : false,
                    btnTpl: {
                        close: '<button data-fancybox-close class="fancybox-button--close fancybox-button-close" title="{{CLOSE}}">' +
                        '<svg width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Мобилка/Меню-открыто" transform="translate(-338.000000, -36.000000)"><g id="Group-2" transform="translate(338.000000, 36.000000)"><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-45.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-315.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect></g></g></g></svg>' +
                        '</button>',
                    },
                    baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
                    '</div>'+
                    '</div>',
                    beforeClose: function () {
                        $('.fancybox-button-close').addClass('fancybox-button-close--hide');

                    }
                });
            },
            scrollInit() {
                $('.announcement__description-wr').mCustomScrollbar({
                    mouseWheel: {
                        enable: true
                    },
                    theme: "rounded-dark",
                    scrollEasing: "linear",
                });
            }
        }
    }
</script>
